import "./Projects.module.css";
import EnTêteDeNavigation from "@/reusable_sections/Header";
import EtudesDeCas from "./sections/EtudesDeCas";
import AnalyzedCaseStudies from "./sections/AnalyzedCaseStudies";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <EnTêteDeNavigation />
      <EtudesDeCas />
      <AnalyzedCaseStudies />
      <Footer />
    </div>;
}